import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: {},
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,

  reducers: {
    updateTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { updateTheme } = themeSlice.actions;

export const getStoredTheme = (state) => state.theme;

export default themeSlice.reducer;
